module.exports = "<div class=\"col-md-12\">\n  <div class=\"form-group\" [formGroup]=\"group\">\n    <label class=\"control-label\">{{ config.label }}</label>\n    <input type=\"password\" class=\"form-control\" value=\"{{ config.value }}\" [attr.placeholder]=\"config.placeholder\" [formControlName]=\"config.name\"/>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/dynamic-form/components/form-password/form-password.component.html
// module id = ./src/app/modules/shared/dynamic-form/components/form-password/form-password.component.html
// module chunks = main